module.exports = __webpack_public_path__ + "static/media/antimatter_background_logo.38aa34f4.svg";